export default __webpack_public_path__ + "static/media/CorporateExecutiveCard.cea680ac.pdf";